import { Component } from '@angular/core';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateFRParserFormatter } from './ngb-date-fr-parser-formatter';

@Component({
  selector: 'app-root',
  providers: [{ provide: NgbDateParserFormatter, useClass: NgbDateFRParserFormatter }],
  template: '<router-outlet><spinner></spinner></router-outlet>'
})
export class AppComponent {
  constructor() {}
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/app.component.ts